<button *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i"
    (click)="onClick(i+1)">
    <span class="mat-icon text-yellow-400 text-3xl">
        {{showIcon(i)}}
    </span>
</button>
